<template>
  <div>
    <!-- Filter Start -->
    <div class="filter">
      <div class="row align-items-center">
        <div class="col-lg">
          <h2 class="page-title text-inter">User Management</h2>
        </div>
        <div class="col-lg-2">
          <div class="input-group">
            <input class="form-control filterInput text-gray-light border-0" type="search" placeholder="Search"
              aria-label="Search" v-model="filter.search" @input="updateTable" />
            <div class="input-group-append">
              <button class="btn btn-outline-light text-gray border-0 bg-white" type="button">
                <i class="fa fa-search"></i>
                <!-- Assuming you're using Font Awesome for the magnifier icon -->
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6"></div>
        <!-- <div v-if="this.user.status === 1" class="col-lg-2"> -->
        <div v-if="this.user.type === 'SUPER ADMIN'" class="col-lg-2">
          <router-link to="/dashboard/user-management/create" class="btn btn-primary new-user-btn"
            style="color: white; text-decoration: none; width: 100%">
            New User
          </router-link>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <div class="bg-white box-content mt-4 scan-history-table-wrapper">
      <!-- <div v-if="tableLoading" class="text-center mt-3 mb-3">
        <h4>Loading...</h4>
      </div> -->

      <!-- v-else -->
      <div style="overflow-x: auto; overflow-y: hidden">
        <table class="table scan-history-table" style="margin: 0">
          <thead>
            <tr>
              <th style="padding-left: 20px; padding-top: 20px;">Username</th>
              <th style="padding-top: 20px;">User Type</th>
              <th style="padding-top: 20px;">Product</th>
              <th style="padding-top: 20px;">Status</th>
              <th style="padding-top: 20px;" v-if="user.type === 'SUPER ADMIN'">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="`${row.id || index}-${index}`">
              <td style="padding-left: 20px;">{{ row.username }}</td>
              <td>{{ row.roles || "-" }}</td>
              <td>{{ row.product_category.join(", ") || "-" }}</td>
              <td style="text-align: left;">
                <span :class="getStatusClass(row.status)">
                  {{ formatStatus(row.status) }}
                </span>
              </td>
              <td v-if="user.type === 'SUPER ADMIN'">
                <button class="btn btn-edit-custom btn-sm" @click="editUser(row)">
                  Edit
                </button>
              </td>
            </tr>
            <tr v-if="!tableLoading && tableData.length === 0">
              <td :colspan="user.type === 'SUPER ADMIN' ? 5 : 4" class="text-center">No data available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row mt-3 pagination-divider"
        v-if="!tableLoading && (tableData.length > 0 || total > 0 || maxPage > 1)">
        <div class="col-12 d-flex align-items-center justify-content-between flex-wrap mb-3 pl-3">
          <div class="d-flex align-items-center">
            <span class="view-per-page-text" style="margin-right: 8px; color: #a3a4a6; font-size: 14px">
              View
            </span>
            <select v-model.number="limitPerPage" @change="onLimitChange"
              class="form-control form-control-sm text-inter"
              style="width: auto; display: inline-block; padding: 4px 8px">
              <option v-for="option in limitPerPageOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select>
            <span class="view-per-page-text" style="margin-left: 8px; color: #a3a4a6; font-size: 14px">
              items per page
            </span>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <p class="mt-2 mb-2 view-per-page-text" style="color: #a3a4a6; margin-right: 20px">
              Showing Page {{ currentPage }}
            </p>
            <nav class="pagination-minimal">
              <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                <li class="page-item" :class="{ disabled: currentPage <= 1 || tableLoading }"
                  @click.stop.prevent="changePage('prev')">
                  <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                </li>
                <li class="page-item" :class="{
                  disabled:
                    tableLoading ||
                    (!hasMoreData && currentPage >= maxPage && maxPage !== 0),
                }" @click.stop.prevent="changePage('next')">
                  <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import debounce from "debounce";

export default {
  metaInfo: {
    title: "User Settings",
  },
  data() {
    return {
      user: this.$store.getters.currentUser,
      modal: {
        new: false,
        edit: false,
        editData: false,
      },
      filter: {
        search: "",
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      limitPerPageOptions: [10, 25, 50, 100],
      sortBy: "id",
      sortOrder: "DESC",
      fetchDataTimer: null,
    };
  },
  computed: {
    hasMoreData() {
      return this.tableData.length === this.limitPerPage;
    },
  },
  watch: {
    "filter.search"(newVal, oldVal) {
      if ((newVal || "").trim() === (oldVal || "").trim()) return;
      this.scheduleFetch();
    },
  },
  mounted() {
    console.log("current user:", this.user);
    this.fetchData(true);
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  methods: {
    scheduleFetch(immediate = false) {
      this.currentPage = 1;
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }
      if (immediate) {
        this.fetchData(true);
        return;
      }
      this.fetchDataTimer = setTimeout(() => {
        this.fetchData(true);
      }, 300);
    },
    async fetchData(resetPage = false) {
      if (resetPage) {
        this.currentPage = 1;
      }

      const params = {
        limit: this.limitPerPage,
        page: this.currentPage,
        order: this.sortOrder,
        by: this.sortBy,
      };

      if (this.filter.search && this.filter.search.trim()) {
        params.search = this.filter.search.trim();
      }

      const queryString = qs.stringify(params, {
        skipNulls: true,
        encodeValuesOnly: true,
      });

      this.tableLoading = true;

      try {
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const resp = await this.$httpSSO.get(`/api/admin/user?${queryString}`, {headers});
        console.log("API Response:", resp.data);

        const responseData = resp.data ;
        const data = responseData.data || [];
        const pageInfo = (responseData && responseData.meta) || {};

        // console.log("Response data:", responseData);
        console.log("Data", data);
        console.log("Page info:", pageInfo);

        this.tableData = Array.isArray(data) ? data : [];
        console.log("Table data:", this.tableData);
        // this.tableData = data;
        // console.log();
        
        this.currentPage = Number(pageInfo.page || this.currentPage);
        // If we got a full page of results, assume there might be more pages
        this.maxPage =
          (this.tableData.length === this.limitPerPage
            ? this.currentPage + 1
            : this.currentPage);
        // Total count might not be in response, so we'll estimate based on current page and data length
        this.total = this.tableData.length;
      } catch (error) {
        console.error("Failed to fetch user data:", error);
        console.error("Error response:", error.response);
        this.tableData = [];
        this.currentPage = 1;
        this.maxPage = 1;
        this.total = 0;
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.currentPage = 1;
      this.fetchData();
    },
    changePage(direction) {
      if (this.tableLoading) return;

      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
        this.fetchData();
        return;
      }

      const hasNextPage =
        this.hasMoreData || (this.maxPage && this.currentPage < this.maxPage);

      if (direction === "next" && hasNextPage) {
        this.currentPage += 1;
        this.fetchData();
      }
    },
    editUser(row) {
      // Navigate to the edit page with the user data
      this.$router.push({
        name: "UUser",
        params: { data: row },
      });
    },
    updateTable: debounce(function (e) {
      this.scheduleFetch();
    }, 500),
    formatUserType(roles) {
      if (!roles) return "-";
      if (Array.isArray(roles)) {
        return roles.map((r) => r.name || r).join(", ");
      }
      if (typeof roles === "string") {
        return roles;
      }
      return "-";
    },
    getStatusClass(status) {
      // if (!status || status.trim() === "") return "";
      if (status == null) return "";
      // const statusUpper = status.toUpperCase().trim();
      if (status === 1) {
        return "status-span bg-custom-green";
      } else if (status === 0) {
        return "status-span bg-custom-red";
      }
      return "";
    },
    formatStatus(status) {
      // if (!status || status.trim() === "") return "-";
      // const statusUpper = status.toUpperCase().trim();
      if (status == null) return "";

      if (status === 1) {
        return "Active";
      } else if (status === 0) {
        return "Inactive";
      }
      return status;
    },
    // deleteUser (userId) {
    //     this.$swal.fire({
    //         title: 'Are you sure?',
    //         text: "You are about to end this (man/woman)'s whole career!",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085D6',
    //         cancelButtonColor: '#D33',
    //         confirmButtonText: 'Delete'
    //     }).then((result) => {
    //         if (result.value) {
    //             this.$http.delete("/admin/update?id=" + userId)
    //             .then((resp)=>{
    //                 this.$swal.fire({
    //                     title : "Success!",
    //                     icon : "success",
    //                     type : "success",
    //                     text : `User has been successfully deleted`
    //                 })
    //             })
    //             .catch((error)=>{
    //                 console.log('%cerror DashboardUserUM.vue line:78 ', 'color: red; display: block; width: 100%;', err);
    //                 this.$swal.fire({
    //                     title : "Error!",
    //                     icon : "error",
    //                     type : "error",
    //                     text : err.response.data.message
    //                 })
    //             })
    //         }
    //     })
    // }
  },
};
</script>

<style>
.status-span {
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  font-family: "Inter", sans-serif !important;
}

.status-span.bg-custom-green {
  /* background-color: transparent; */
  color: #34ce4c;
}

.status-span.bg-custom-red {
  /* background-color: #e74c3c; */
  color: #CD2E2C;
}

.btn-edit-custom {
  border-color: #efefef !important;
  color: #ababab !important;
  background-color: transparent;
  font-family: "Inter", sans-serif !important;
}

.btn-edit-custom:hover {
  border-color: #efefef !important;
  color: #ababab !important;
  background-color: transparent;
  font-family: "Inter", sans-serif !important;
}

.text-inter {
  font-family: "Inter", sans-serif !important;
}

.new-user-btn {
  font-family: "Inter", sans-serif !important;
}

.view-per-page-text {
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper.box-content {
  padding: 0;
}
</style>

<style scoped>
.page-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

.box-content {
  border-radius: 10px;
}

.pagination-divider {
  border-top: 1px solid #e6e6e6;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 16px;
  overflow: hidden;
}

.btn-pretty {
  background-color: #dbebff;
  color: #267ce5;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
}

.statsData {
  padding: 10px 7px;
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}

.bg-kecamatan {
  background-color: blueviolet;
}

.bg-desakel {
  background-color: darkslategray;
}

.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}
</style>

<style scoped>
.not-selected-button {
  color: #4b4b4b;
  background-color: #ffffff;
  border: none;
}

.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.ahm-button-circular {
  width: 40px;
  /* Set the width and height to the same value for a perfect circle */
  height: 40px;
  border-radius: 50%;
  /* Makes the button circular */
  background-color: #d8e4ff;
  /* Sets the background color */
  padding: 10px 20px;
  /* Adjust padding to fit your content */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
}

.ahm-modal-description {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2d2d2d;
  opacity: 1;
}

.ahm-modal-title {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #4b4b4b;
  opacity: 1;
}

.ahm-modal-body {
  /* Set a fixed width and height for the container, or use relative units like % if needed */
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Hide any overflowing content */
}

.modal {
  display: block;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 45%;
  /* Could be more or less, depending on screen size */
}

.close {
  color: black;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style>
.ahm-table thead tr th,
.table-title {
  font-weight: normal;
  color: #bcbcbc;
  text-align: left !important;
}

.ahm-table thead tr th,
.ahm-table tbody tr td {
  vertical-align: middle;
  font-size: 14px;
  text-align: left !important;
}

.ahm-table .no-border td {
  border: 0;
  padding: 5px;
}

.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
  font-weight: 700;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table thead th.sortable {
  cursor: pointer;
}

.scan-history-table-wrapper .scan-history-table thead th .sort-icon {
  font-size: 12px;
  color: #4b4b4b;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
  font-weight: 400;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled) .page-link:hover {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>